// @flow

import React from "react";
import { compose } from "recompose";

import { withI18n } from "@quantum/i18n";
import { ConfirmationModal, withModal } from "@quantum/ui";

type Props = {
  message: string,
};

type EnhancedProps = {
  show: boolean,
  onHide: Function,
  translate: Function,
};

const enhance = compose(withModal("errorAssetGroup"), withI18n);

const ErrorAssetGroupModal = ({
  message,
  show,
  onHide,
  translate,
}: Props & EnhancedProps) => (
  <ConfirmationModal
    buttonOk={translate("Comum.Ok")}
    header={translate("Comum.Atencao")}
    message={message}
    show={show}
    onConfirm={onHide}
    onHide={onHide}
  />
);

export default enhance(ErrorAssetGroupModal);
